/**
 * Recebe veeFields e retorna um Boolean indicando se tem ou não erros.
 * @param {Object} veeFields Objeto de validação dos campos de um formulário que usa o Vee-Validate.
 */
export function hasFieldsWithErrors (veeFields) {
	const fields = Object.keys(veeFields);
	const erros = fields.filter(f => veeFields[f].invalid);
	return Boolean(erros.length);
}
